import axios from 'axios';
import UrlAPI from '../../components/UrlAPI';

export default class CadastrarEstabelecimentoApi {
  static cadastrarEstabelecimento(values, resolve, reset) {
    return dispatch => {

      // Código provisório
      values.tipo = "OPERADOR";

      axios.post(`${UrlAPI.getUrl()}/public/usuario-estabelecimento/`, values)
        .then(() =>{
          resolve();
          window.grecaptcha.reset();
          dispatch(reset('formIntegrar'));
          dispatch({type:"MSGSUCCESS", msg:"Usuário cadastrado com sucesso"})
        })
        .catch(err => {
          if (err.response.data.message) {
            dispatch({type:"MSGERROR", msg:err.response.data.message})
          } else {
            dispatch({type:"MSGERROR", msg:"Não foi possível cadastrar usuário, por favor, tente novamente mais tarde."})
          }
          resolve();
        })
    }
  }
}


// WEBPACK FOOTER //
// ./src/logicas/Validador/CadastrarEstabelecimentoApi.js